import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "accordion" }
const _hoisted_3 = {
  class: "accordion-header",
  id: "accordion-header-registration-user"
}
const _hoisted_4 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapse-actions",
  "aria-controls": "collapse-actions"
}
const _hoisted_5 = {
  class: "accordion-collapse collapse",
  id: "collapse-actions",
  "aria-labelledby": "collapse-actions"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = {
  class: "btn btn-secondary",
  type: "submit"
}
const _hoisted_11 = { class: "col-8 text-end" }
const _hoisted_12 = {
  href: "#top",
  class: "btn btn-outline-dark rounded-circle size-square-5 sticky-above-main-form-bottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SubHeader = _resolveComponent("SubHeader")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainFormBottomBar = _resolveComponent("MainFormBottomBar")!
  const _component_FormRenderComponent = _resolveComponent("FormRenderComponent")!
  const _component_ProgressWheel = _resolveComponent("ProgressWheel")!
  const _component_b_icon_arrow_up = _resolveComponent("b-icon-arrow-up")!
  const _component_MainFormContainer = _resolveComponent("MainFormContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, { position: "" }),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_SubHeader, {
          key: 0,
          "link-to-overview": `/field_of_action_overview/${_ctx.application.id}`,
          "link-to-overview-title": _ctx.$t('text.back_to_fields_of_action')
        }, null, 8, ["link-to-overview", "link-to-overview-title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Alerts, { sticky: "sticky-below-page-form-nav" }),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_MainFormContainer, {
          key: 1,
          title: _ctx.$t('fields_of_action.edit_field', { number: _ctx.foaNumber }),
          "title-cls": "h3 fw-normal text-muted mb-3",
          subtitle: _ctx.$t(_ctx.getFieldTitle(_ctx.fieldOfAction.field_of_action_type)),
          "subtitle-cls": "h2",
          "is-json-form": ""
        }, {
          form: _withCtx(() => [
            (_ctx.fieldOfAction.id)
              ? (_openBlock(), _createBlock(_component_FormRenderComponent, {
                  key: 0,
                  "form-object": _ctx.fieldOfAction,
                  "empty-optionlabel": _ctx.$t('text.select_empty'),
                  ref: "form",
                  onSubmitted: _ctx.handleSubmit,
                  onChanged: _ctx.updateState,
                  isReadOnly: _ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod)
                }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", _hoisted_4, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('meta.pageTitles.actions_overview')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('fields_of_action.action_subtitle')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentApplicationActions, (action) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: action.id,
                            class: "form-check"
                          }, [
                            _createVNode(_component_Field, {
                              name: "actions",
                              class: "form-check-input",
                              id: 'form-check-action-' + action.id,
                              value: action.id,
                              type: "checkbox",
                              disabled: _ctx.applicationInReadonlyMode(_ctx.application, _ctx.currentApplicationPeriod),
                              modelValue: _ctx.fieldOfAction.actions,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldOfAction.actions) = $event)),
                              onChange: _ctx.checkForCount
                            }, null, 8, ["id", "value", "disabled", "modelValue", "onChange"]),
                            _createElementVNode("label", {
                              class: "form-check-label",
                              for: 'form-check-action-' + action.id
                            }, _toDisplayString(action.title), 9, _hoisted_6)
                          ]))
                        }), 128)),
                        _hoisted_7,
                        _createVNode(_component_router_link, {
                          to: { name: 'ApplicationActionOverview', params: { id: _ctx.application.id }},
                          class: "d-inline-block"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('fields_of_action.to_action')), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createTextVNode(" – " + _toDisplayString(_ctx.$t('fields_of_action.to_action_description')), 1)
                      ])
                    ]),
                    (!_ctx.formIsReadOnly())
                      ? (_openBlock(), _createBlock(_component_MainFormBottomBar, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$t('text.intermediate_save')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("button", {
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleFinish()), ["prevent"])),
                                  class: "btn btn-outline-primary"
                                }, _toDisplayString(_ctx.$t('text.finish')), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["form-object", "empty-optionlabel", "onSubmitted", "onChanged", "isReadOnly"]))
              : _createCommentVNode("", true)
          ]),
          "form-progress": _withCtx(() => [
            (_ctx.showErrors)
              ? (_openBlock(), _createBlock(_component_ProgressWheel, {
                  state: _ctx.currentFormState,
                  key: _ctx.currentFormState,
                  class: "sticky-below-page-form-nav"
                }, null, 8, ["state"]))
              : (_openBlock(), _createBlock(_component_ProgressWheel, {
                  state: _ctx.getStateOfFoa(_ctx.fieldOfAction, _ctx.getFieldOfActionActionBorders(this.application.organization)),
                  key: _ctx.currentFormState,
                  class: "sticky-below-page-form-nav"
                }, null, 8, ["state"])),
            _createElementVNode("a", _hoisted_12, [
              _createVNode(_component_b_icon_arrow_up)
            ])
          ]),
          _: 1
        }, 8, ["title", "subtitle"]))
      : _createCommentVNode("", true)
  ], 64))
}